import css from './language.module.css';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from '../../util/reactIntl';
import {
  Footer,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  Page,
} from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import BrochurePageComponent from '../../components/BrochurePage/BrochurePageComponent';
import { ReactComponent as LineSmallSvgNew } from '../../assets/crissCrossSmallNew.svg';

const HeadingTextMob = () => {
  return (
    <p className={`${css.firstHeaderTop} ${css.showForMob}`}>
      Inspire confidence through
      <br />
      <span className={css.tiltedHeighlight}>
        {' '}
        <span className={css.innerTiltText}>language</span>
      </span>{' '}
      — we’ll handle the{' '}
      <div className={css.headerStyle}>
        <LineSmallSvgNew className={`${css.lineSvg}`} />
        admin
      </div>
    </p>
  );
};

const HeaderText = () => {
  return (
     <p className={`${css.firstHeaderTop} ${css.hideForMob}`}>
      Inspire confidence through
      <br />
      <span className={css.tiltedHeighlight}>
        {' '}
        <span className={css.innerTiltText}>language</span>
      </span>{' '}
      — we’ll handle the{' '}
      <div className={css.headerStyle}>
        <LineSmallSvgNew className={`${css.lineSvg}`} />
        admin
      </div>
    </p>
  );
};

const LanguagePage = (props) => {
  const { isAuthenticated, currentUser } = props;
  const isProvider = currentUser?.attributes?.profile?.publicData?.isProvider;
  const pageDescription = `Whether you teach French, Spanish, Irish, Mandarin, or English — if you’re helping children or adults build confidence through language, we’re here to manage the admin behind the scenes. From registrations and payments to sign-in sheets and reminders, Activity Time keeps your lessons running smoothly so you can focus on what really matters — helping your students find their voice.`;
  return (
    <Page>
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <BrochurePageComponent
            isAuthenticated={isAuthenticated}
            isProvider={isProvider}
            headingText={<HeaderText />}
            headingTextMob={<HeadingTextMob />}
            pageName="Language"
            pageDescription={pageDescription}
            pageBannerImg={`language_bannerImage.png`}
            secondSecTitle={
              'Your admin assistant for languages — fluent in organisation.'
            }
            secondSecSubTitle={
              'See how our language class management software can make admin a thing of the past.'
            }
            secondSecMainPic={'language_secondMainNew.png'}
            secondSecLogo={'language_secondLogoNew.png'}
            secondSecName={'Clodagh'}
            secondSecNameDes={'After-School Language Classes'}
            secondSecDesc={`“Before Activity Time, I used to track my grind classes on paper, confirming places and money by phone. Now, I love online bookings. I check sign-ups from any device, plus I can still take cash balances. It saves me hours every week.”`}
            secondSecSub={'Let’s make learning languages'}
            thirdSecFirstTitle={`Teach. Communicate. Connect. We’ll handle the rest.`}
            thirdSecSecondTitle={`Stay focused on every word that counts`}
            thirdSecFirstPic={`language_thirdFirstNew.png`}
            thierdSecSecondPic={`language_thirdSecondNew.png`}
            thirdSecParaText={`We know the real learning happens in the classroom, not in the paperwork!`}
            testimonialPic={`language_testimonialNew.png`}
            testimonialTitle={`Miguel, Spanish Tutor`}
            testimonialDesc={`“In less than an hour my grind classes were live online. I don’t miss the spreadsheets, volumes of parent messages and missed payments. My customers are 100% happier too.”`}
          />
        </LayoutWrapperMain>
        <LayoutWrapperFooter hasNegative={true}>
          <Footer hideFirstWave={true} />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  const { currentUserListing, currentUserListingFetched, currentUser } = state.user;
  const { isAuthenticated } = state.Auth || {};

  return {
    currentUserListing,
    currentUserListingFetched,
    currentUser,
    isAuthenticated,
  };
};
export default compose(withRouter, connect(mapStateToProps), injectIntl)(LanguagePage);
